/// <reference path="../../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
namespace Nobox.Nobox {

    @Serenity.Decorators.registerClass()
    export class CampaignResultTotalDialog extends Serenity.TemplatedDialog<CampaignResultTotalDialogOptions> {

        protected form = new CampaignForm(this.idPrefix);

        constructor(opt: CampaignResultTotalDialogOptions) {
            super(opt);
            this.dialogTitle = Q.format("Total", /*this.options.username*/"");
            this.initNumberFormatter();
            this.getData();
        }

        initNumberFormatter() {
            const value = `; ${document.cookie}`;
            const parts = value.split(`; formatnumber=`);
            if (parts[1] == undefined) {
                this.element.find(".formatedNumber").autoNumeric('init');
            } else {
                var formatnumber = JSON.parse(decodeURIComponent(parts[1].split(';').shift()));
                if (jQuery.isEmptyObject(formatnumber)) {
                } else {
                    var obj = {};
                    if ('aDec' in formatnumber) {
                        obj["aDec"] = formatnumber["aDec"];
                    }
                    if ('mDec' in formatnumber) {
                        obj["mDec"] = formatnumber["mDec"];
                    }
                    if ('aSep' in formatnumber) {
                        obj["aSep"] = formatnumber["aSep"];
                    }
                    if ('dGroup' in formatnumber) {
                        obj["dGroup"] = formatnumber["dGroup"];
                    }
                    if ('lZero' in formatnumber) {
                        obj["lZero"] = formatnumber["lZero"];
                    }
                    this.element.find(".formatedNumber").autoNumeric('init', obj);
                }
            }
        }

        updateNumberFormatter() {
            const value = `; ${document.cookie}`;
            const parts = value.split(`; formatnumber=`);
            if (parts[1] == undefined) {
                this.element.find(".formatedNumber").autoNumeric('update');
            } else {
                var formatnumber = JSON.parse(decodeURIComponent(parts[1].split(';').shift()));
                if (jQuery.isEmptyObject(formatnumber)) {
                } else {
                    var obj = {};
                    if ('aDec' in formatnumber) {
                        obj["aDec"] = formatnumber["aDec"];
                    }
                    if ('mDec' in formatnumber) {
                        obj["mDec"] = formatnumber["mDec"];
                    }
                    if ('aSep' in formatnumber) {
                        obj["aSep"] = formatnumber["aSep"];
                    }
                    if ('dGroup' in formatnumber) {
                        obj["dGroup"] = formatnumber["dGroup"];
                    }
                    if ('lZero' in formatnumber) {
                        obj["lZero"] = formatnumber["lZero"];
                    }
                    this.element.find(".formatedNumber").autoNumeric('update', obj);
                }
            }
        }

        getData() {
            var elQueue = this.element.find(".formatedNumber.queue");
            var elProcess = this.element.find(".formatedNumber.process");
            var elSent = this.element.find(".formatedNumber.sent");
            var elFailed = this.element.find(".formatedNumber.failed");
            var elCanceled = this.element.find(".formatedNumber.canceled");

            Q.serviceCall({
                url: "/Services/" + CampaignresultService.baseUrl + "/Total",
                blockUI: false,
                request: {
                    EntityId: this.options.Id
                },
                success: res => {
                    var item = res.Entity;
                    elQueue.text(item.Queue);
                    elProcess.text(item.Process);
                    elSent.text(item.Sent);
                    elFailed.text(item.Failed);
                    elCanceled.text(item.Canceled);
                    this.updateNumberFormatter();
                }
            });
        }

        getTemplate() {
            return `<div class="row">
                        <div class="col">
                            <div class="card s-dashboard-card-sm bg-secondary">
                                <div class="card-body">
                                    <h3 class="formatedNumber queue">0</h3>
                                    <p>Queue</p>
                                </div>
                                <div class="icon">
                                    <i class="fa fa-list"></i>
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <div class="card s-dashboard-card-sm bg-warning">
                                <div class="card-body">
                                    <h3 class="formatedNumber process">0</h3>
                                    <p>Process</p>
                                </div>
                                <div class="icon">
                                    <i class="fa fa-clock-o"></i>
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <div class="card s-dashboard-card-sm bg-success">
                                <div class="card-body">
                                    <h3 class="formatedNumber sent">0</h3>
                                    <p>Sent</p>
                                </div>
                                <div class="icon">
                                    <i class="fa fa-check"></i>
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <div class="card s-dashboard-card-sm bg-danger">
                                <div class="card-body">
                                    <h3 class="formatedNumber failed">0</h3>
                                    <p>Failed</p>
                                </div>
                                <div class="icon">
                                    <i class="fa fa-times-circle"></i>
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <div class="card s-dashboard-card-sm bg-danger">
                                <div class="card-body">
                                    <h3 class="formatedNumber canceled">0</h3>
                                    <p>Canceled</p>
                                </div>
                                <div class="icon">
                                    <i class="fa fa-close"></i>
                                </div>
                            </div>
                        </div>
                    </div>`;
        }
    }

    export interface CampaignResultTotalDialogOptions {
        Id: string;
    }
}